import {isDate, parseISO} from "date-fns";

export const tryParseDate = (value: any): Date | null => {
    if (isDate(value)) {
        return value;
    }
    if (value && typeof value === 'string') {
        return parseISO(value);
    }
    return null;
}
